import React from 'react';
import EducationContext from './EducationContext';

export default function EducationWrapper(props) {
  const { form, children } = props;
  return <EducationContext.Provider value={{ form }}>{children}</EducationContext.Provider>;
}
